import api from '@/common/http/testapi'

const isWeiXin = () => {
  const ua = navigator.userAgent.toLowerCase()
  const isWXWork = ua.match(/wxwork/i) == 'wxwork'
  const isWeixin = !isWXWork && ua.match(/micromessenger/i) == 'micromessenger'
  return isWeixin
}

/**
 * 获取元素样式
 * @param styleObj
 * @param scalePoint 缩放比例
 */
let getCommonStyle = function (styleObj, scalingRatio = 1) {
  let needUnitStr = ['width', 'height','top', 'left', 'paddingTop', 'paddingLeft', 'paddingRight', 'paddingBottom', 'marginTop', 'marginLeft', 'marginRight', 'marginBottom', 'borderWidth','fontSize', 'borderRadius', 'letterSpacing']
  let style ={}

  for (let key in styleObj){
    if(needUnitStr.includes(key)){
      let w = window.screen.width;
      style[key] = (styleObj[key] * scalingRatio) * (w / 375) + 'px'
    }else{
      style[key] = styleObj[key]
    }
  }
  style.transform = `rotate(${style.rotate}deg)`
  style.backgroundImage = style.backgroundImage ? `url(${style.backgroundImage})` : '';
  return style;
}

const parser = (str) => {
	let obj = {};
	str.replace(/([^&=]*)=([^&=]*)/g, function() {
		let i=arguments[2].indexOf('/');
		obj[arguments[1]] = i>-1?arguments[2].split('/').join(''):arguments[2];
	});
	return obj;
}

const wxShareConfig = config => {
  console.log(wx)
  const url = window.location.href.split('#')[0]
  const params = {
    client_oauth_token: 'EastfairCreditApplication',
    appId: 'wxfedbcc05541526fb',
    url: url
  }

  api.weChatConfigParams(params).then(res => {
    const data = res.data.data
    wx.config({
      debug: false,
      appId: data.appId, // 必填，公众号的唯一标识
      timestamp: data.timestamp, // 必填，生成签名的时间戳
      nonceStr: data.nonceStr, // 必填，生成签名的随机串
      signature: data.signature,// 必填，签名
      jsApiList: [
        'updateTimelineShareData', // 分享朋友圈接口
        'updateAppMessageShareData' // 分享给朋友接口
      ]
    });

    wx.ready(() => {
      const shareConfig = {
        title: config.title,
        desc: config.desc,
        imgUrl: config.imgUrl,
        link: window.location.href,
        success: function(res) {
          console.log(res)
        },
        fail: function(res) {
          console.log(res)
        }
      }
      wx.updateAppMessageShareData(shareConfig);
      wx.updateTimelineShareData(shareConfig);
    })
  })
}

const isInMiniprogram = async () => {
  return new Promise(resolve => {
    wx.miniProgram.getEnv((res) => {
      if (res.miniprogram) {
          console.log('在小程序内');
          resolve(true)
      } else {
          console.log('不在小程序内');
          resolve(false)
      }
    })
  })
}


export default {
    isWeiXin,
    getCommonStyle,
    parser,
    wxShareConfig,
    isInMiniprogram
}